<template>
<v-layout row wrap>
  <v-flex xs12>


    <v-flex xs12 v-if="filterRole(['agremiado','nuevo-ingreso'])">
      <v-card>

        <v-card-title pa-0 primary-title class="grey lighten-4">
          <v-tooltip top>
            <v-btn slot="activator" dark @click.stop="dialog = true" icon class="mx-0">
               <v-icon color="red">help</v-icon>
            </v-btn>
             <span>Atención técnica</span>
          </v-tooltip>
          <h3 class="headline mb-0">Información de Actuaciones</h3>
        </v-card-title>

              <!-- Inicio de las tarjetas -->
          <v-layout row wrap>
            <v-flex sm12 xs12 md4 lg4 pa-1>
              <statscard color="green" icon="mdi-account" title="Mis Actuaciones" :value="`${misactuaciones}`" sub-icon="mdi-file-document" sub-text="RAP" />
            </v-flex>
            <v-flex sm12 xs12 md4 lg4  pa-1>
              <statscard  color="orange" icon="mdi-information-outline" title="Actuaciones Pendientes" :value="`${pendientes}`" sub-icon="mdi-file-document" sub-text="RAP" />
            </v-flex>
            <v-flex sm12 xs12 md4 lg4  pa-1>
              <statscard color="blue" icon="mdi-cash" title="Actuaciones por Revisar" :value="`${porrevisar}`" sub-icon="mdi-file-document" sub-text="RAP"  />
            </v-flex>
          </v-layout>
      </v-card>
    </v-flex>
</v-flex>

  <v-flex xs12>
      <v-layout>
        <v-flex>
            <v-card>
                  <v-card-title  primary-title>
                    <div>
                      <h3 class="headline mb-0">Protección Profesional</h3>
                      <div>
                        <p>Documentos técnicos a ser protegidos por
                        este Colegio de Contadores Públicos del Distrito Capital según la narturaleza comercial del cliente,
                        en cuanto a la aplicación correcta de la norma técnica y aspectos de forma y presentación.
                        </p>
                      </div>
                    </div>
                  </v-card-title>

                  <v-treeview
                    :open="open"
                    :items="items"
                    activatable
                    item-key="name"
                    open-on-click
                  >
                   <template slot="label" slot-scope="{ item }">
                      <a v-if="item.document_type_id != null" @click="sendToActuacion(item)">{{ item.name }}</a>
                      <div v-else>{{ item.name }}</div>
                    </template>
                    <template v-slot:prepend="{ item, open }">
                      <v-icon v-if="item.document_type_id == null">
                        {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                      </v-icon>
                      <v-icon v-else>
                        {{ 'mdi-file' }}
                      </v-icon>
                    </template>
                  </v-treeview>

                <v-card-actions>
                  <v-btn color="primary darken-1"  :to="{ name: 'nueva-actuacion' }">REGISTRAR ACTUACION</v-btn>
                </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
</v-flex>

    <v-dialog v-model="dialog" max-width="600">
      <v-card>
        <v-card-title class="headline">Servicios</v-card-title>
        <v-card-text>
          Indicadores de primer nivel relacionado con el Servicio de Registro de Actuación Profesional Electrónico del Contador Público Colegiado.
          <br>
          <ul>
            <li>
              Aquí podra visualizar la cantidad de actuaciones, según estatus.
            </li>
          </ul>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat="flat" @click="dialog = false">
            Salir
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import statscard from '~/components/material/StatsCard.vue'


export default {
  name: "view-home",

  components: {
     statscard
  },

  data () {
    return {
      data: [],
      agremiados: '0',
      nuevoIngreso: '0',
      closedRuaps: '0',
      ruapsSinContestar: '0',
      ruapsHoy: '0',
      misactuaciones: '0',
      pendientes: '0',
      porrevisar: '0',
      dialog: false,
      loading: false,
      items: [],
      open: ['public'],
    }
  },

  computed: {
    ...mapGetters({
        user: 'authUser'
    })
  },

  mounted() {
    this.$store.dispatch('fetchUser')
    this.getAdminMetricas()
    this.getDocumentTypes()
  },

  methods: {

    sendToActuacion(item) {
      this.$router.push({ name: 'nueva-actuacion', params: { item } })
    },

    filterRole(role) {
      let exists = false
      exists = this.user.roles.filter(rol => {
        for (let index = 0; index < role.length; index++) {
          if(rol.slug === role[index]){
            return rol
          }
        }
      }).length != 0 ? true : false

      return exists
    },

    async getDocumentTypes(){
      await axios.get(`/api/document_types/document-types-mapa`)
              .then(resp => {
                this.items = resp.data.dt
              }).catch(error => {
                console.log(error.response)
              })
    },

    recorridoActuaciones(metricas){
      let porrevisar = 0
      let pendientes = 0
      this.misactuaciones = metricas.length
      metricas.forEach(rape => {
        let count = 0
        let valido = 0
        rape.document_requiremets.forEach(element => {
            if(element.supervisor_check == null){
              count++
            }
            if(element.supervisor_check == true){
              valido++
            }
        });
        if(count != 0){
          porrevisar++
        }
        if(valido == rape.document_requiremets.length && rape.service_payments.length == 0){
          pendientes++
        }

        if(rape.service_payments.length != 0){
          if(rape.service_payments[0].invoice.agreement == false){
            pendientes++
          }
        }
      });

      this.porrevisar = porrevisar
      this.pendientes = pendientes
    },

    async getAdminMetricas(){
      await axios.get(`/api/metricas`).then(resp => {
        // console.log(resp.data, 'data')
        this.agremiados = resp.data.agremiados
        this.closedRuaps = resp.data.closedRuaps
        this.ruapsSinContestar = resp.data.ruapsSinContestar
        this.nuevoIngreso = resp.data.nuevos
        this.ruapsHoy = resp.data.ruapsHoy
        if(resp.data.metricas_agremiado.length != 0){
          this.recorridoActuaciones(resp.data.metricas_agremiado)
        }
      }).catch(error => {
        console.log(error.response)
      })
    }

  }

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/home.vue